import React from 'react';
import { Badge } from 'syngenta-digital-cropwise-react-ui-kit';
import './index.css';

interface BlueBadgeProps {
  children: React.ReactNode;
  visible?: boolean;
}

const BlueBadge: React.FC<BlueBadgeProps> = ({ children, visible = true }) => {
  return (
    <div className="flex w-full blue-badge">
      <Badge
        dot
        color="#0092E4"
        size="default"
        count={visible ? 1 : 0}
        showZero={false}
        className="flex grow w-full"
      >
        {children}
      </Badge>
    </div>
  );
};

export default BlueBadge;
